module.exports = __webpack_public_path__ + "static/media/googleIcon.695a3160.svg";